export const RECOVERY_CODE_LENGTH = 10;

export const RECOVERY_CODE_ERROR_MESSAGE = "Recovery code not found";
